import React, { useEffect } from "react";
import "../output.css";
import createShareGroopOrder from "../queries/createShareGroopOrder";

const TestApi = () => {
  useEffect(() => {
    createShareGroopOrder()
      .then((response) => response.json())
      .then((data) => {
        console.log("Payment order List: ", data);
      })
      .catch((err) => {
        console.log("Yen err", err);
      });
  }, []);
  return <div></div>;
};

export default TestApi;
